
import Header from "../Components/Header"

import Footer from "../Components/Footer";
import CommonLanding from "../Components/CommonLanding";
import "swiper/css";
import "swiper/css/navigation";
export default function PreWeddingLanding() {
  return (
    <>
    <CommonLanding
      title="Cinematic Pre-Wedding Shoots on the Water"
      subtitle="Capture your love story in luxury"
      heading="Your Love Story, Framed by the Horizon"
      text="Luxury yacht photoshoots with skyline views and romantic experiences before your big day."
      image="https://images.unsplash.com/photo-1520857014576-2c4f4c972b57"
      ctaText="Book Your Shoot"
      schema={{
        "@context": "https://schema.org/",
        "@type": "Service",
        "serviceType": "Pre-Wedding Yacht Photoshoot"
      }}
      features={[
        { title: "Golden Hour", desc: "Best natural lighting." },
        { title: "Cabins", desc: "Changing rooms available." },
        { title: "Drone Ready", desc: "Perfect for aerial shots." }
      ]}
    />
      <Header />

      <section className="ib-bday-wrapper">
        {/* HERO */}
        <div className="ib-bday-hero">
          <div className="ib-bday-container">
            <h1 className="ib-bday-title">
              Cinematic Pre-Wedding Shoots on the Water
            </h1>
            <p className="ib-bday-subtitle">
              Capture your love story with a luxury yacht experience.
            </p>
          </div>
        </div>

        {/* INTRO */}
        <div className="ib-bday-section">
          <div className="ib-bday-container ib-bday-grid">
            <div className="ib-bday-content">
              <h2 className="ib-bday-heading">
                Your Love Story, Framed by the Horizon
              </h2>
              <p className="ib-bday-text">
                Our yachts provide 360° views of the Mumbai skyline and Arabian Sea.
                It’s not just a photoshoot—it’s a romantic experience before your big day.
              </p>
            </div>

            <div className="ib-bday-image">
              <img src="https://images.unsplash.com/photo-1520857014576-2c4f4c972b57" />
            </div>
          </div>
        </div>

        {/* FEATURES */}
        <div className="ib-bday-features">
          <div className="ib-bday-container">
            <h2 className="ib-bday-heading-center">What You Get</h2>

            <div className="ib-bday-feature-grid">
              <div className="ib-bday-card">
                <h3>Golden Hour Access</h3>
                <p>Perfect lighting for stunning photos.</p>
              </div>

              <div className="ib-bday-card">
                <h3>Changing Rooms</h3>
                <p>Fully equipped cabins for outfit changes.</p>
              </div>

              <div className="ib-bday-card">
                <h3>Drone Friendly</h3>
                <p>Open decks for cinematic aerial shots.</p>
              </div>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="ib-bday-cta">
          <div className="ib-bday-container ib-bday-cta-inner">
            <a href="/contact" className="ib-bday-btn">
              Book Your Shoot
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}
